<template>
  <div class="container-fluid">
    <div class="row g-0">
      <!-- <div class="col-3">
        <search-agency-list class="search" />
      </div> -->
      <div class="col-8">
        <button
          class="btn btn-agency btn-success"
          @click="addNewAgency"
        >
          Add New Agency
        </button>
        <vue-good-table
          ref="table"
          :key="tableKey"
          class="vue-table"
          :columns="columns"
          :rows="agencyList"
          :isLoading.sync="isLoading"
          styleClass="vgt-table condensed bordered"
          @row-click="onRowClick"
          @page-change="onPageChange"
          @per-page-change="onPerPageChange"
          @sort-change="onSortChange"
          :pagination-options="paginationOptions"
          ><template #table-row="props">
             <!-- selected row show blue color -->
            <span v-if="props.row.uuid == currentAgencyUuid">
              <span style="font-weight: bold; color: blue">{{
                props.formattedRow[props.column.field]
              }}</span></span
            >
            <span v-else>{{ props.formattedRow[props.column.field] }}</span>
           
            <!-- api return null , has_proxy = no  -->
            <span v-if="props.column.field == 'proxyName'">
                <span v-if="props.row.proxyName== null">No</span>
                <!-- <span v-else>{{ props.formattedRow[props.column.field] }}</span> -->
              </span>
          </template>
        </vue-good-table>
      </div>
      <div class="col-4">
        <agency-list-item id="backgroundLayout" class="agency-list-item" /> 
      </div>
    </div>
 
  </div>
  <add-new-agency-modal  />
  <error-modal />
  <edit-agency-modal />
</template>

<script setup lang="ts">
import GlobalData from "@/GlobalData";
import AgencyListItem from "@/components/AgencyList/AgencyListItem.vue";
import SearchAgencyList from "@/components/AgencyList/SearchAgencyList.vue";
import AddNewAgencyModal from "@/components/Modal/AddNewAgencyModal.vue";
import EditAgencyModal from "@/components/Modal/EditAgencyModal.vue";
import ErrorModal from "@/components/Modal/ErrorModal.vue";
import { ref, onMounted ,watch } from "vue";
import { useAgencyStore } from "@/stores/agency";
import {  useAsyncState } from "@vueuse/core";
import { Modal } from "bootstrap";


let errorModal: any; 
let errorEditModal: any; 
let addNewAgencyModal: any;
let editAgencyModal: any;
onMounted(() => {
  GlobalData.getInstance().changeBackgroundPosition = changeBackgroundPosition;
  errorModal = new Modal(document.getElementById('errorModal')!);
  errorEditModal = new Modal(document.getElementById('errorEditModal')!);
  addNewAgencyModal = new Modal(document.getElementById('addNewAgencyModal')!);
  editAgencyModal = new Modal(document.getElementById('editAgencyModal')!);
  paginationOptions.value = {
  enabled: true,
  mode: 'pages',
  perPage: 20,
  perPageDropdown: [10, 20, 30],
  dropdownAllowAll: false,
  setCurrentPage: 1,
  allLabel: 'All',
  };
  agencyStore.updateUuid(0)
});

const agencyStore = useAgencyStore();
const isLoading = ref(false);
const tableKey = ref(0);
const table = ref();

const forceRerender = () => {
  tableKey.value += 1;
}

watch(() => agencyStore.errorModalVisible, (visible) => {
  if (visible) {
    errorModal.show();
  }
});

watch(() => agencyStore.errorEditModalVisible, (visible) => {
  if (visible) {
    errorEditModal.show();
  }
});

watch(() => agencyStore.addNewAgencyModalVisible, (visible) => {
  if (visible) {
    addNewAgencyModal.show();
  }
});

watch(() => agencyStore.editAgencyModalVisible, (visible) => {
  if (visible) {
    editAgencyModal.show();
  }
});

watch(
  () => agencyStore.loading,
  (updateLoading) => (isLoading.value = updateLoading)
);

const agencyList:any =ref([]);
const currentAgencyUuid:any = ref("");

watch(
  () => agencyStore.afterProcessAgency,
  (updateAgency) => {
    agencyList.value = updateAgency.slice().sort((a, b)=> b.number - a.number)
    //  agencyList.value = updateAgency;
  }
);

watch(
  () => agencyStore.currentAgencyUuid,
  (update) => {
    currentAgencyUuid.value = update;
  }
);

watch(
  () => agencyStore.reloadTable,
  () => {
    forceRerender();
  }
)

const currentPerPage = ref(agencyStore.currentPerPage);
const currentPage = ref(agencyStore.currentPage);

watch(
  () => agencyStore.currentPerPage,
  (update) => {
    currentPerPage.value = update
  }
);

watch(
  () => agencyStore.currentPage,
  (update) => {
    currentPage.value = update
  }
)

const addNewAgency = () => {
  agencyStore.openAddNewModal();
}

// provide("selectedRowData",agencyStore.afterProcessAgency );
// provide("data", agencyStore.afterProcessAgency);
const changeBackgroundPosition = (remove, add) => {
  let backgroundLayout: any = document.getElementById("backgroundLayout");
  backgroundLayout.classList.remove(remove);
  backgroundLayout.classList.add(add);
};

const paginationOptions = ref({
  enabled: true,
  mode: 'pages',
  perPage: currentPerPage.value,
  perPageDropdown: [10, 20, 30],
  dropdownAllowAll: false,
  setCurrentPage: currentPage.value,
  allLabel: 'All',
});

//click next
const onPageChange = (params) => {
  // let indexOfFirstItem = params.currentPerPage * (params.currentPage - 1);
  // currentAgencyUuid.value = agencyList.value[indexOfFirstItem].uuid
  // agencyStore.storeCurrent(params.currentPage, params.currentPerPage)
  // agencyStore.fetchAgency(agencyList.value[indexOfFirstItem])

  // after sorting change some logic
  let indexOfFirstItem = params.currentPerPage * (params.currentPage - 1);
   currentAgencyUuid.value = table.value.filteredRows[0].children[indexOfFirstItem].uuid
   agencyStore.storeCurrent(params.currentPage, params.currentPerPage)
   agencyStore.fetchAgency( table.value.filteredRows[0].children[indexOfFirstItem])
};

const onPerPageChange = (params) => {
  // currentAgencyUuid.value = agencyList.value[0].uuid
  // agencyStore.storeCurrent(1, params.currentPerPage)
  // agencyStore.fetchAgency(agencyList.value[0])

  // after sort change some logic
  currentAgencyUuid.value = table.value.filteredRows[0].children[0].uuid
  agencyStore.storeCurrent(1, params.currentPerPage)
  agencyStore.fetchAgency(table.value.filteredRows[0].children[0])
}

const onRowClick = (params) => {
  agencyStore.fetchAgency(params.row)
}

const onSortChange = (params) => {
  isLoading.value = true;
  setTimeout(() => {
    currentAgencyUuid.value = table.value.filteredRows[0].children[0].uuid
  console.log("!",table.value.filteredRows[0].children[0])
  agencyStore.storeCurrent(1, params.currentPerPage)
  
  agencyStore.fetchAgency(table.value.filteredRows[0].children[0])
    isLoading.value = false;
  }, 500);
};

const columns = [
  {
    label: "Agency ID",
    field: "id",
    sortable: false,
    width: "15%",
  },
  {
    label: "Agency Name",
    field: "name",
    
  },
  {
    label: "Agency SFTP Username",
    field: "sftpUsername",
    sortable: false,
    width: "15%",
  },
  {
    label: "Is Proxy",
    field: "isProxy",
    width: "15%",
    formatFn: function (value: any) {
      if (value == true) {
        return "Yes";
      } else {
        return "No";
      }
    },

  },
  {
    label: "Has Proxy?",
    field: "hasProxy",
    width: "15%",
    formatFn: function (value: any) {
      if (value == true) {
        return "Yes";
      } else {
        return "No";
      }
    },
  },
  {
    label: "Active/Inactive",
    field: "active",
    sortable: false,
    width: "15%",
    formatFn: function (value: any) {
      if (value == true) {
        return "Active";
      } else {
        return "Inactive";
      }
    },
  },
  // {
  //   label: "Has Originator?",
  //   field: "isProxy",
  //   sortable: false,
  //   width: "15%",
  // },
  // {    
  //   label: "Proxy/ Orginator",
  //   field: "isProxy",
  //   sortable: false,
  //   width: "15%",

  // },

];


const { execute, error } = useAsyncState(() => {
  return agencyStore.fetchAgencyList();
}, null);
</script>

<style scoped>
.btn-agency {
  float: right;
  margin: 10px;
  z-index: 1;
}
.vue-table {
  padding-right: 10px;
  width: 100%;
  overflow: auto;
}
.agency-list-item {
  position: fixed;
  top: 60px;
  overflow: auto;
  height: 100%;
}
.background-layout {
  /* used to change style when modal is active */
  position: relative;
  overflow: auto;
  height: 100%;
}
</style>
